import ajax from "@/lib/ajax";

/**
 * 读取审计日志
 * @param payload 
 */
export async function QueryAuditLog(payload: any){
	let res = await ajax.post('/api/services/app/AuditLog/QueryAuditLog', payload)
	return res.data.result
}


// WEBPACK FOOTER //
// ./src/api/audit/auditLog.ts